<div class="config-container">
  <!-- Heading -->
  <div class="section">
    <h2 class="title">
      <mat-icon color="primary">bar_chart</mat-icon>
      Current Product Scores
    </h2>
    <p>Product Fit For Market Score: <b>{{ currentMarketScore }}</b></p>
    <p>Financial & Strategic Score: <b>{{ currentFinancialScore }}</b></p>
  </div>

  <hr style="margin-bottom: 0;margin-top: 0;" />

  <!-- Target Scores -->
  <div class="section">
    <h3 class="subtitle">
      <mat-icon color="warn">track_changes</mat-icon>
      Set Your Target Scores
    </h3>

    <div class="fields-container">
  <!-- Market Score -->
  <div class="field">
    <label> Target Product Fit For Market Score (X): </label>
    <div class="slider-input-container">
      <span>{{ marketSliderMin }}</span>
      <input
        class="slider"
        type="range"
        [min]="marketSliderMin"
        [max]="sliderMax"
        [step]="sliderStep"
        [(ngModel)]="marketScore"
      />
      <span>{{ sliderMax }}</span>
      <input
        class="score-input"
        type="number"
        [min]="marketSliderMin"
        [max]="sliderMax"
        [step]="sliderStep"
        [(ngModel)]="marketScore"
      />
    </div>
  </div>

  <!-- Financial Score -->
  <div class="field">
    <label> Target Financial & Strategic Significance Score (Y): </label>
    <div class="slider-input-container">
      <span>{{ financialSliderMin }}</span>
      <input
        class="slider"
        type="range"
        [min]="financialSliderMin"
        [max]="sliderMax"
        [step]="sliderStep"
        [(ngModel)]="financialScore"
      />
      <span>{{ sliderMax }}</span>
      <input
        class="score-input"
        type="number"
        [min]="financialSliderMin"
        [max]="sliderMax"
        [step]="sliderStep"
        [(ngModel)]="financialScore"
      />
    </div>
  </div>
</div>


  </div>

  <hr style="margin-bottom: 0;margin-top: 0;" />

  <!-- Generation Settings -->
  <div class="section">
    <h3 class="subtitle">
      <mat-icon color="accent">settings</mat-icon>
      Generation Settings
    </h3>

    <!-- Scenarios Dropdown -->
    <div class="field">
      <label>Number Of Scenarios To Generate</label>
      <select [(ngModel)]="scenarios">
        <option *ngFor="let s of availableScenarios" [ngValue]="s">
          {{ s }}
        </option>
      </select>

    </div>

    <mat-slide-toggle [(ngModel)]="applyConfig" style="margin-top: 4px;">Add Config Settings</mat-slide-toggle>


    <!-- Tolerance Slider -->
    <!-- <div class="field">
      <label> Tolerance:<b>{{ tolerance.toFixed(2) }}</b> </label>
      <div class="slider-input-container">
        <span>0.1</span>
        <input class="tolerance-slider" type="range" min="0.1" max="2.0" step="0.1" [(ngModel)]="tolerance" />
        <span>2.0</span>
        <input class="score-input" type="number" min="0.1" max="2.0" step="0.1" [(ngModel)]="tolerance" />
      </div>
    </div> -->

  </div>

  <!-- Button -->
  <div class="actions">
    <button (click)="generateScenarios()">
      <!-- <mat-icon>bolt</mat-icon> -->
      Generate Scenarios
    </button>
  </div>
</div>